import React, { useState, useEffect } from 'react';
import { Typography, Card, Progress } from 'antd';
import { useNavigate } from 'react-router-dom';
import AppHeader from './Header'; // Import the shared header component
import './common.css'; // Import the common CSS file
import './Borrow.css'; // Import the CSS file
import './BorrowHistory.css'; // Import the new CSS file

const { Title } = Typography;

const BorrowHistory = () => {
    const navigate = useNavigate();
    const [borrowHistory, setBorrowHistory] = useState([]);
    const [totalPoints, setTotalPoints] = useState(0);
    const [userName, setUserName] = useState(sessionStorage.getItem('name'));

    useEffect(() => {
        const userId = sessionStorage.getItem('userId');
        if (userId) {
            fetchBorrowHistory(userId);
        } else {
            console.error('User not logged in');
        }
    }, []);

    const fetchBorrowHistory = async (userId) => {
        try {
            const response = await fetch(`https://54.178.141.189/users/${userId}/history`);
            const data = await response.json();
            setBorrowHistory(data.history);
            setTotalPoints(data.points);
        } catch (error) {
            console.error('Error fetching borrow history:', error);
        }
    };

    const handleLogout = () => {
        sessionStorage.clear();
        setUserName(null);
        window.location.href = '/login';
    };

    return (
        <div>
            <AppHeader userName={userName} handleLogout={handleLogout} />
            <div style={{ position: 'relative', display: 'flex', justifyContent: 'center', alignItems: 'flex-start', height: '100vh' }}>
                <div className="content-container-app">
                    <Title level={1} style={{ fontFamily: 'Normal', fontSize: '2.5rem', fontWeight: 'bold', textAlign: 'center' }}>臺大循環餐盒系統試辦計畫</Title>
                    <p style={{ fontFamily: 'Normal', fontSize: '2rem', fontWeight: 'bold', textAlign: 'center', marginTop: '0.5rem' }}>NTU ECOntainer Pilot Program</p>
                    <img src="/eco-packaging.png" alt="Logo" style={{ width: '25%'}} />
                    <Title level={2} className="sub-title">借用歷史</Title>
                    <p style={{ fontFamily: 'Normal', fontSize: '2rem', fontWeight: 'bold', textAlign: 'center', marginTop: '0rem', marginBottom: "0rem" }}>Borrow History</p>
                    <div className="total-points">
                        <p style={{ fontFamily: 'Normal', fontSize: '1.5rem', fontWeight: 'bold', textAlign: 'center' }}>累計點數 Total Points: {totalPoints}</p>
                    </div>
                    <div className="survey-link">
                        <p style={{ fontFamily: 'Normal', fontSize: '1.2rem', textAlign: 'center' }}>
                            <a href="https://docs.google.com/forms/d/e/1FAIpQLSfoD2kTJkT9t5MYQXSVJeTQ01sShx6xVUQ_r40oyBsu36cMng/viewform" target="_blank" rel="noopener noreferrer">回饋表單 Feedback Form</a>.
                        </p>
                    </div>
                    <div className="history-list">
                        {borrowHistory.map((entry, index) => (
                            <Card
                                key={index}
                                className="history-card"
                                title={
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        {entry.event === 'borrow-return' ? (
                                            <>
                                                <Progress type="circle" percent={100} width={30} />
                                                <p style={{ marginLeft: '10px' }}>成功歸還 Successful Return</p>
                                            </>
                                        ) : (
                                            <>
                                                <Progress type="circle" percent={50} status="exception" width={30} />
                                                <p style={{ marginLeft: '10px' }}>尚未歸還 Pending Return</p>
                                            </>
                                        )}
                                    </div>
                                }
                            >
                                {entry.event === 'borrow-return' ? (
                                    <>
                                        <p>借用 Borrow ：{new Date(entry.borrowTime).toLocaleString()}</p>
                                        <p>歸還 Return ：{new Date(entry.returnTime).toLocaleString()}</p>
                                        <p>點數 Points ：{entry.points}</p>
                                    </>
                                ) : (
                                    <>
                                        <p>借用 Borrow：{new Date(entry.borrowTime).toLocaleString()}</p>
                                        <p>尚未歸還 Pending Return</p>
                                    </>
                                )}
                            </Card>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BorrowHistory;